import TopNavigationLayoutPageContent from 'shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'
import AdminNavigationProtectionLayout from 'shared/Layouts/TopNavigationLayout/AdminNavigationProtectionLayout'
import GradeFilters from './components/gradeTableFilters/GradeTableFilterts'
import GradeTable from './components/gradeTable/GradeTable'

const ProtectionGradeAdminPage = () => {
  return (
    <AdminNavigationProtectionLayout>
      <TopNavigationLayoutPageContent type='default'>
        <div className='flex-space-between'>
          <div className='inline-flex-gap' style={{ gap: '2.5em' }}>
            <h2 className='page--header'>Оценки</h2>
          </div>
        </div>
        <GradeFilters />
        <GradeTable />
      </TopNavigationLayoutPageContent>
    </AdminNavigationProtectionLayout>
  )
}

export default ProtectionGradeAdminPage
